'use client';

import { useEffect } from 'react';
import { applyThemePreference } from '@/lib/theme-preference';

export default function ThemeInitializer() {
  useEffect(() => {
    // Dark mode is not yet fully implemented — lock to light until all
    // components are audited for dark-mode contrast issues.
    applyThemePreference('light');
  }, []);

  return null;
}
